import { useEffect, useState, useCallback } from "react";
import { api, errMsg } from "@/lib/api";
import { PageHeader, Loading, ErrorState, StatCard } from "@/components/common";
import { Card, CardContent } from "@/components/ui/card";
import { CalendarRange, Clock, CheckCircle2 } from "lucide-react";

export default function AssistanceMinutes() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true); setError("");
    try { setData(await api.physioAssistance()); }
    catch (e) { setError(errMsg(e)); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <Loading />;
  if (error) return <ErrorState message={error} onRetry={load} />;

  const d = data || {};
  const prescribed = d.prescribed_minutes ?? 0;
  const executed = d.executed_minutes ?? 0;
  const pct = prescribed > 0 ? Math.round((executed / prescribed) * 100) : null;

  return (
    <div>
      <PageHeader title="Minuti assistenziali" subtitle={`Periodo ${d.period || ""} · ${d.from || ""} → ${d.to || ""}`} />
      <div className="mb-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <StatCard icon={Clock} label="Minuti prescritti" value={prescribed} testId="stat-prescribed" />
        <StatCard icon={CheckCircle2} label="Minuti eseguiti" value={executed} tint="accent" testId="stat-executed" />
        <StatCard icon={CalendarRange} label="Completamento" value={pct != null ? `${pct}%` : "—"} testId="stat-completion" />
      </div>

      <Card className="border-border/70">
        <CardContent className="p-6">
          <div className="flex items-center justify-between text-sm text-muted-foreground">
            <span>Eseguiti</span><span>{executed} / {prescribed} min</span>
          </div>
          <div className="mt-2 h-3 w-full overflow-hidden rounded-full bg-muted">
            <div className="h-full rounded-full bg-primary transition-all" style={{ width: `${Math.min(pct || 0, 100)}%` }} data-testid="assistance-bar" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
